<template>
    <v-content>
      <v-container fluid>
        <h1 class="py-3">Sigfox Dashboard</h1>
      </v-container>
    </v-content>
</template>

<script>
export default {
  name: 'SigfoxDashboard',
  components: { },
  data: () => ({
  })
}
</script>
